import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { get } from 'lodash-es';
import { getContainerWideSelector } from 'common/selectors';
import { sizeSelector } from 'common/selectors';
import { getSearchTermSelector } from 'pages/search.page/selectors';
import { contentMaskSelector } from 'components/header/content-mask/selector';
import { contentMaskHideAction, contentMaskShowAction } from 'components/header/content-mask/actions';
import { HamburgerMenu } from 'components/header/navigation-bar/hamburger-menu';
import { CreateVideoNavItem } from 'components/header/navigation-bar/upload-nav-item';
import { SearchForm } from 'components/header/navigation-bar/search-form';
import { SearchNavItem } from 'components/header/navigation-bar/search-nav-item';
import { DesktopMenuContent } from 'components/header/navigation-bar/desktop-menu-content';
import { MobileMenu } from 'components/header/navigation-bar//mobile-menu';
import { SearchNavItemMobile } from 'components/header/navigation-bar/search-nav-item-mobile';

const mapPropsToState = (state, props) => ({
  searchTerm: getSearchTermSelector(state, props.match),
  showContentMask: contentMaskSelector(state),
  containerWide: getContainerWideSelector(state),
  size: sizeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  showContentMaskAction: () => dispatch(contentMaskShowAction()),
  hideContentMaskAction: () => dispatch(contentMaskHideAction()),
});

class NavigationBar extends React.Component {
  state = {
    showHideSearchForm: false,
  };

  navigation = React.createRef();

  componentDidMount() {
    this.setState({
      showHideSearchForm: this.props.searchTerm !== undefined,
    });

    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  showHideSearchForm = () => {
    const toggleShow = !this.state.showHideSearchForm;
    this.setState({
      showHideSearchForm: toggleShow,
    });
    this.props.hideContentMaskAction();
  };

  showHideMobileMenu = () => {
    if (!this.props.showContentMask) {
      this.props.showContentMaskAction();
    } else {
      this.props.hideContentMaskAction();
    }

    this.setState({
      showHideSearchForm: false,
    });
  };

  onKeyDown = (event) => {
    // Close the mobile menu when the escape key is pressed
    if (event.key === 'Escape' && this.props.showContentMask) {
      this.props.hideContentMaskAction();
    }
  };

  render() {
    return (
      <Fragment>
        <div
          className="ct-responsive-nav-bar"
          data-e2e={`${this.props.containerWide ? 'nav-bar-desktop' : 'nav-bar-mobile'}`}
        >
          <div
            className={`ct-responsive-nav-bar__container${
              this.props.containerWide ? ' ct-responsive-nav-bar__container--wide' : ''
            }`}
          >
            <nav className="ct-responsive-nav-bar__navigation-items" ref={this.navigation}>
              {/* Desktop navigation */}
              <DesktopMenuContent
                navigationChannels={this.props.navigationChannels}
                navigationRootChannels={this.props.navigationRootChannels}
                availableWidth={get(this.navigation, 'current.clientWidth')}
              />

              {/* Mobile navigation */}
              <HamburgerMenu onClick={this.showHideMobileMenu} menuOpen={this.props.showContentMask} />
              <div className="ct-responsive-nav-bar__mobile-menu-hook">
                <MobileMenu
                  className={`ct-responsive-nav-bar__mobile-menu${
                    this.props.showContentMask ? ' ct-responsive-nav-bar__mobile-menu--active' : ''
                  }`}
                  showHideMobileMenu={this.showHideMobileMenu}
                />
              </div>
            </nav>
            <div className="ct-responsive-nav-bar__items">
              {this.props.withUpload && <CreateVideoNavItem />}
              <SearchNavItemMobile showForm={this.state.showHideSearchForm} onClick={this.showHideSearchForm} />
              <SearchNavItem
                className="ct-responsive-nav-bar__search-nav-item"
                showHide={this.state.showHideSearchForm}
                onClick={this.showHideSearchForm}
              />
            </div>
          </div>
        </div>
        {this.state.showHideSearchForm && <SearchForm className="ct-responsive-nav-bar__search-form-container" />}
      </Fragment>
    );
  }
}

export const NavigationBarDecorated = compose(withRouter, connect(mapPropsToState, mapDispatchToProps))(NavigationBar);
